import type { CSSProperties } from "react";

/*
 * THE FELT'S SHARED PIECES — what حکم (`HokmTable`) and بی‌دل (`HeartsTable`) draw the same way.
 * The NUMBERS each table measured for itself stay in that table: its trick-slot clamps (حکم's
 * `TRICK_SIDE` / `TRICK_TOP` / `TRICK_DROP` / `TRICK_OWN`; بی‌دل's `TRICK_SIDE` and the `trickTop` /
 * `trickDrop` / `trickOwn` it builds from a measured `trickKt`), its `SIDE_NAME_MAX`, and حکم's
 * `CEREMONY_SIDE` / `CEREMONY_TOP` / `CEREMONY_BOTTOM`.
 */

/** Avatar sizes, regular → zoomed (`useCompactTable`: below 400 px of width, or below 700 px of
 *  height with no touch pointer). A seat's ring adds 2 px each side, its shadow 2 px more. */
export const SEAT_AVATAR = { regular: 40, compact: 32 } as const;
/** Your own avatar, in the strip under the felt — regular → zoomed. */
export const OWN_AVATAR = { regular: 38, compact: 32 } as const;

/** A slot position the felt's size decides, held in a custom property and used through `var()`:
 *  happy-dom's CSS parser drops any `clamp()` from `left`/`top` (so no test could read it) but
 *  keeps a custom property verbatim, and every browser substitutes it at the `left`/`top` where the
 *  `50%` inside still means half the felt. */
export const atX = (value: string): CSSProperties =>
  ({ "--slot-x": value, left: "var(--slot-x)" }) as CSSProperties;
export const atY = (value: string): CSSProperties =>
  ({ "--slot-y": value, top: "var(--slot-y)" }) as CSSProperties;
